import OrganizationView from './OrganizationView';

export default OrganizationView;
